module.exports = __webpack_public_path__ + "img/slider-17.7ac292be.jpg";